import React from 'react';
import { LFC } from '../../Legacy';
import { Button, Prompt } from '../../ui';
import { useResolve } from '../Container';
import { BoardUsageModel } from '../account/BoardUsageModel';
import { Copy, Em, Flexer } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';

export const boardCreateOverLimitPopup = () => ({ ui: BoardCreateOverLimitPopup, args: {} });

export const BoardCreateOverLimitPopup: LFC<PopupProps> = ({ action, dismiss }) => {
    const { limit, boards } = useResolve(BoardUsageModel);
    const target = boards[boards.length - 1];
    return <Prompt ignoreEnter onAction={dismiss}>
        <Popup w={36}>
            <Popup.Close onAction={dismiss} />
            <Flexer flex center>
                <Popup.Title>Active Board Limit Reached</Popup.Title>
            </Flexer>
            <Popup.Content>
                <Copy>
                    You&apos;ve reached your limit of {limit} editable boards.  Creating a new board will set <Em>{target.label}</Em> to <Em>View Only</Em>.
                    Upgrade for unlimited editable boards and other cool stuff!
                </Copy>
            </Popup.Content>
            <Flexer height="1" />
            <Flexer flex="row" center gap=".5">
                <Button variant="primary" onAction={() => action(true)}>Create Anyway</Button>
                <Button variant="common" onAction={() => action(false)}>Upgrade</Button>
            </Flexer>
        </Popup>
    </Prompt>;
};

export const boardCreateOverLimitDashboardNextPopup = () => ({ ui: BoardCreateOverLimitDashboardNextPopup, args: {} });

export const BoardCreateOverLimitDashboardNextPopup: LFC<PopupProps> = ({ action, dismiss }) => {
    const { limit, boards } = useResolve(BoardUsageModel);
    return <Prompt ignoreEnter onAction={dismiss}>
        <Popup w={36}>
            <Popup.Close onAction={dismiss} />
            <Flexer flex center>
                <Popup.Title>Free Board Limit Reached</Popup.Title>
            </Flexer>
            <Popup.Content>
                <Copy>
                    You&apos;ve reached your limit of {limit} free boards.
                    In order to create boards, please either upgrade your account or reduce the number of boards in your team to 3 or less.
                    Upgrading will also unlock lots of other cool stuff!
                    You will love it.
                </Copy>
            </Popup.Content>
            <Flexer height="1" />
            <Flexer flex="row" center gap=".5">
                <Button variant="positive" onAction={() => action(true)}>Upgrade</Button>
                <Button variant="common" onAction={() => action(false)}>Close</Button>
            </Flexer>
        </Popup>
    </Prompt>;
};
